import { getHStatementsObject } from 'ghs-hazard';
import { Compound } from 'pubchem';

/**
 * We check that the hazards are present in the reagents
 * @param {object} reagent
 */
export async function ensureHazardAndPhysical(reagent, options = {}) {
  const { logger } = options;
  if (reagent.hazards && reagent.hStatements) return;

  if (reagent.hazards) {
    if (typeof reagent.hazards === 'string') {
      reagent.hazards = reagent.hazards.split(',').map((h) => h.trim());
    }
    reagent.hStatements = reagent.hazards.map((h) => getHStatementsObject()[h]);
    return;
  }

  try {
    const compound = await Compound.fromSmiles(reagent.smiles);
    const data = await compound.getData();
    const summary = data.getGHSSummary({ sourceName: 'European' });
    reagent.hStatements = summary.hStatements;
    reagent.hazards = reagent.hStatements.map((h) => h.code);
  } catch (e) {
    logger.error(
      `Could not get hazards for ${reagent.smiles}: ${e.toString()}`,
    );
    reagent.hStatements = [];
    reagent.hazards = [];
  }
}
